import { useCallback, useRef } from 'react';
import { trackTelemetry } from '../api';

export function useTelemetry() {
  const lastPage = useRef('');

  const track = useCallback(async (eventType, page, feature = '', detail = '') => {
    try {
      await trackTelemetry({ event_type: eventType, page, feature, detail });
    } catch {
      // silently fail — telemetry should never block UX
    }
  }, []);

  const trackPageView = useCallback((page) => {
    if (page !== lastPage.current) {
      lastPage.current = page;
      track('page_view', page);
    }
  }, [track]);

  const trackFeature = useCallback((page, feature, detail = '') => {
    track('feature_use', page, feature, detail);
  }, [track]);

  return { trackPageView, trackFeature };
}
